import { useSnackbar } from "@homebound/beam";
import { useNavigate } from "react-router-dom";
import { ChangeEventStatus } from "src/generated/graphqlTypes";
import {
  BaseChangeEventFormInput,
  BaseChangeEventFormState,
} from "src/routes/projects/change-events/guided/baseChangeEventForm";
import { WorkflowActionArgs } from "src/routes/projects/change-events/guided/workflows/types";
import { createChangeEventUrl } from "src/RouteUrls";
import { useReviewStep_SaveChangeEventMutation } from "./useReviewStepActions.generated";

export function useReviewStepActions<F extends BaseChangeEventFormInput>(args: WorkflowActionArgs<F>) {
  const { form, projectId } = args;
  const navigate = useNavigate();
  const { triggerNotice } = useSnackbar();
  const [saveChangeEvent] = useReviewStep_SaveChangeEventMutation();
  const reviewForm = form as typeof form & BaseChangeEventFormState<F>;

  return {
    submit: async () => {
      if (!form.canSave()) return;

      const result = await saveChangeEvent({
        variables: {
          structureId: projectId,
          input: {
            id: reviewForm.id.value,
            title: reviewForm.title.value,
            internalNote: reviewForm.internalNote.value,
            reasonId: reviewForm.reasonId.value,
            hasPreSignedContract: reviewForm.hasPreSignedContract.value,
            documentId: reviewForm.documentId.value,
            status: ChangeEventStatus.Requested,
          },
        },
      });
      const savedChangeEvent = result.data?.saveChangeEvent.changeEvent;
      if (!savedChangeEvent) return;

      form.update(savedChangeEvent);

      triggerNotice({ message: "Change event created" });
      navigate(createChangeEventUrl(projectId, savedChangeEvent.id));
    },
  };
}
